export default __webpack_public_path__ + "static/media/2.7a40e601.jpg";